// // Custom events have been added to the theme to make adding
// // custom functionality easier. The below events have been
// // exposed as well as the associated data for each event.
// // To enable this functionality update the 'useCustomEvents' variable in
// // the theme.liquid file to 'true'.

// // This event fires whenever an item has been added to the cart.
// // This event is exposed when the ajax cart is enabled.
// // The product object is passed within the detail object.
// document.addEventListener("cart:item-added", function (evt) {
//   console.log("Item added to the cart");
//   console.log(evt.detail.product);
// });

// // This event fires whenever the cart is updated.
// // This event is exposed when the ajax cart is enabled.
// // The cart object is passed within the detail object.
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });

// // This event fires whenever there is an error when adding an item to the cart.
// // This error is typically due to a product not having sufficient stock.
// // The error message is passed within the detail object.
// document.addEventListener("cart:error", function (evt) {
//   console.log("Cart error");
//   console.log(evt.detail.errorMessage);
// });

// // This event fires whenever the quick cart is opened.
// // This event is exposed when the ajax cart is enabled.
// // The cart object is passed within the detail object.
// document.addEventListener("quick-cart:open", function (evt) {
//   console.log("Quick cart opened");
//   console.log(evt.detail.cart);
// });

// // This event fires whenever the quick cart is opened.
// // This event is exposed when the ajax cart is enabled.
// document.addEventListener("quick-cart:close", function () {
//   console.log("Quick cart closed");
// });

// // This event fires whenever a variant product is selected.
// // This event is exposed when a 'Variant selectors' block has been added to
// // a product template or featured product section
// // The selected variant object is passed within the detail object.
// document.addEventListener("product:variant-change", function (evt) {
//   console.log("Product variant changed");
//   console.log(evt.detail.variant);
// });

// // This event fires whenever a product quanatiy is updated.
// // This event is exposed when a 'Quantity selector' block has been added to
// // a product template or featured product section
// // The quantity and selected variant object is passed within the detail object.
// document.addEventListener("product:quantity-update", function (evt) {
//   console.log("Product quantity updated");
//   console.log(evt.detail.quantity, evt.detail.variant);
// });

// // This event fires whenever quickview modal is opened.
// // This event is exposed when the 'Enable quick view' feature is enabled
// // And a quick view modal is opened.
// document.addEventListener("quickview:loaded", function () {
//   console.log("Quickview loaded");
// });




document.addEventListener("product:variant-change", function (evt) {
  console.log('evt.detail.variant.id', evt.detail.variant.id);
  // Hide all variant metafields
  document.querySelectorAll('[data-variant-display]').forEach(function(element) {
    element.style.display = 'none';
  });
  
  // Show the selected variant's metafields
  const selectedVariantDisplays = document.querySelectorAll('[data-variant-display="' + evt.detail.variant.id + '"]');
  selectedVariantDisplays.forEach(display => {
    display.style.display = 'block';
  });
});


/**
 * Toggles the visibility of the 'combination unavailable' message
 * based on the selected product variant.
 */
document.addEventListener('product:variant-change', function(evt) {
  // The variant object will be null if the selected combination doesn't exist
  const variant = evt.detail.variant;

  // Find the message element on the page
  // This could be inside a product form, a featured product section, or quick view
  const unavailableMessage = document.querySelector('.combination-unavailable');

  // If the message element doesn't exist on the page, do nothing.
  if (!unavailableMessage) {
    return;
  }

  // The classList.toggle() method is perfect here.
  // The second argument is a boolean:
  // - If `true`, the class is ADDED.
  // - If `false`, the class is REMOVED.

  // We want to HIDE the message when a variant EXISTS.
  // A variant object is "truthy", and null is "falsy".
  // So, we pass the variant directly as the condition.
  const variantExists = variant !== null;
  unavailableMessage.classList.toggle('visually-hidden', variantExists);

  /*
   * Breakdown of the logic:
   * 1. If a valid variant is selected:
   *    - `variantExists` is `true`.
   *    - `toggle('visually-hidden', true)` will ADD the class, hiding the message.
   *
   * 2. If an invalid combination is selected:
   *    - `variant` is `null`, so `variantExists` is `false`.
   *    - `toggle('visually-hidden', false)` will REMOVE the class, showing the message.
   */
});



document.addEventListener('DOMContentLoaded', function () {
  const readMoreWrapper = document.querySelector('.read-more-wrapper');
  if (!readMoreWrapper) return;

  const truncatedContent = readMoreWrapper.querySelector('.read-more-content');
  const fullContent = readMoreWrapper.querySelector('.read-more-full');
  const fullContentInner = fullContent.querySelector('.rte');
  const showMoreButton = readMoreWrapper.querySelector('.read-more-toggle--more');
  const showLessButton = readMoreWrapper.querySelector('.read-more-toggle--less');

  if (showMoreButton) {
    showMoreButton.addEventListener('click', function (event) {
      event.stopPropagation();
      const contentHeight = fullContentInner.offsetHeight + 27;
      fullContent.style.maxHeight = contentHeight + 'px';
      readMoreWrapper.classList.add('is-expanded');
    });
  }

  if (showLessButton) {
    showLessButton.addEventListener('click', function (event) {
      event.stopPropagation();
      fullContent.style.maxHeight = '0px';
      readMoreWrapper.classList.remove('is-expanded');
    });
  }
});


/**
 * Shows the appropriate preorder item(s) and message(s) based on the selected variant.
 *
 * This script does NOT check dates. It trusts that Liquid has already filtered out
 * any HTML for preorder messages whose dates have passed.
 *
 * Logic:
 * 1. The entire container '.product__preorder-item' is shown only if the selected variant is sold out AND a valid message exists.
 * 2. If a variant is sold out:
 *    a. Look for pre-rendered messages specific to that variant (`[data-variant-preorder-message]`). If any exist, show them.
 *    b. If none exist, then and only then, look for the fallback product messages (`[data-product-preorder-message]`) and show those if they exist.
 */
function updatePreorderVisibility(variant) {
  const preorderContainers = document.querySelectorAll('.product__preorder-item');
  const allPreorderMessages = document.querySelectorAll('[data-product-preorder-message], [data-variant-preorder-message]');

  // --- 1. Hide everything to start ---
  preorderContainers.forEach(container => container.style.display = 'none');
  allPreorderMessages.forEach(message => message.style.display = 'none');

  if (!variant) {
    console.log('Preorder Script: No valid variant provided.');
    return;
  }

  const isSoldOut = !variant.available;
  if (!isSoldOut) {
    // console.log(`Preorder Script: Variant ${variant.id} is AVAILABLE. Hiding preorder items.`);
    return;
  }

  // --- 2. If sold out, find all the right messages to show ---
  console.log(`Preorder Script: Variant ${variant.id} is SOLD OUT. Checking for pre-rendered preorder messages...`);
  let messagesToShow = [];

  // Priority 1: Check if specific messages for this variant were rendered by Liquid.
  const variantMessages = document.querySelectorAll(`[data-variant-preorder-message="${variant.id}"]`);
  
  if (variantMessages.length > 0) {
    // If variant-specific messages exist, they are the authority. Use them.
    console.log(`Preorder Script: Found ${variantMessages.length} specific message(s) for variant ${variant.id}.`);
    messagesToShow = Array.from(variantMessages);
  } else {
    // ONLY if the variant has NO messages of its own, fall back to the product-level messages.
    // console.log(`Preorder Script: No specific messages for variant ${variant.id}. Checking for product-level fallbacks.`);
    const productMessages = document.querySelectorAll('[data-product-preorder-message]');
    if (productMessages.length > 0) {
      messagesToShow = Array.from(productMessages);
    }
  }

  // --- 3. Show the containers and the chosen messages ---
  if (messagesToShow.length > 0) {
    messagesToShow.forEach(message => {
      // Show the specific span
      message.style.display = 'inline'; // or 'block' depending on desired layout
      
      // Find its parent container '.product__preorder-item' and show it
      const parentContainer = message.closest('.product__preorder-item');
      if (parentContainer) {
        parentContainer.style.display = 'block';
      }
    });
  } else {
    // console.log(`Preorder Script: Variant ${variant.id} is sold out, but no valid preorder message was found for it or the product.`);
  }
}


// --- SCRIPT EXECUTION (IMPROVED FOR PAGE LOAD) ---
window.addEventListener('load', function() {
  // Use a small timeout to ensure theme scripts have finished their initial setup.
  setTimeout(function() {
    let productData = null;
    try {
      const productJsonScript = document.querySelector('[id^="ProductJson-"], [data-product-json]');
      if (productJsonScript) {
        productData = JSON.parse(productJsonScript.textContent);
      } else {
        console.error("Preorder Script: Product JSON script not found.");
        return;
      }
    } catch (e) {
      console.error("Preorder Script: Could not find or parse product JSON.", e);
      return;
    }

    if (!productData || !productData.variants) {
        console.error("Preorder Script: Product data or variants are missing.");
        return;
    }

    // --- More robust way to find the initial variant ---
    let initialVariantId = null;
    
    // 1. Best method: Check the URL first.
    const urlVariantId = new URL(window.location).searchParams.get('variant');
    if (urlVariantId) {
      initialVariantId = parseInt(urlVariantId, 10);
    }

    // 2. Next best: Check the actual form inputs on the page. This is very reliable.
    if (!initialVariantId) {
      const variantSelector = document.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"][type="hidden"]');
      if (variantSelector && variantSelector.value) {
        initialVariantId = parseInt(variantSelector.value, 10);
      }
    }
    
    // 3. Fallback: Use the first available variant from the JSON.
    if (!initialVariantId && productData.selected_or_first_available_variant) {
        initialVariantId = productData.selected_or_first_available_variant.id;
    }
    
    // 4. Last resort: Just use the very first variant in the list.
    if (!initialVariantId && productData.variants.length > 0) {
        initialVariantId = productData.variants[0].id;
    }

    const initialVariant = productData.variants.find(v => v.id === initialVariantId);
    
    console.log("Preorder Script: Initializing on page load for variant:", initialVariant);
    updatePreorderVisibility(initialVariant);

    // --- Set up listener for subsequent changes ---
    document.addEventListener("product:variant-change", function (evt) {
      const selectedVariant = evt.detail.variant;
      // console.log("Preorder Script: Variant changed via theme event to:", selectedVariant);
      updatePreorderVisibility(selectedVariant);
    });

  }, 100); // 100ms delay is usually plenty for theme scripts to complete.
});